// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var SuffixTreeJs = require("./SuffixTree.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var GenericTree$SmartcutsMacros = require("./GenericTree.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");

function sliceFrom(endPosition, text, from) {
  if (Number.isFinite(endPosition)) {
    return text.slice(from, endPosition + 1 | 0);
  } else {
    return text.slice(from);
  }
}

function childNodes(suffixTree, node) {
  return Belt_Array.map(Object.entries(node.transition), (function (param) {
                var match = param[1];
                return [
                        sliceFrom(match[2], suffixTree.text, match[1]),
                        match[0]
                      ];
              }));
}

function makeWithText(text) {
  var suffixTree = new SuffixTreeJs.SuffixTree();
  return suffixTree.addString(text + "$");
}

function isRoot(node) {
  return node === /* Root */0;
}

function isLeaf(node) {
  if (node) {
    return node._0.nodeRef.isLeaf();
  } else {
    return false;
  }
}

function getText(node) {
  if (node) {
    return node._0.text;
  }
  
}

function childNodes$1(suffixTree, node) {
  var nodeRef = node ? node._0.nodeRef : suffixTree.root;
  return Belt_Array.map(childNodes(suffixTree, nodeRef), (function (param) {
                return /* Node */{
                        _0: {
                          nodeRef: param[1],
                          text: param[0],
                          parentNode: node
                        }
                      };
              }));
}

function traverse(suffixTree, initResult, combineNodeWithResult, rootNode) {
  return GenericTree$SmartcutsMacros.depthFirst((function (param) {
                return childNodes$1(suffixTree, param);
              }), initResult, combineNodeWithResult, rootNode);
}

function frequency(suffixTree, node) {
  return traverse(suffixTree, 0, (function (node, previousResult) {
                if (isLeaf(node)) {
                  return 1 + previousResult | 0;
                } else {
                  return previousResult;
                }
              }), node);
}

function traverse$1($$this, initResult, combineNodeWithResult, rootNodeOpt, param) {
  var rootNode = rootNodeOpt !== undefined ? rootNodeOpt : /* Root */0;
  return traverse($$this, initResult, combineNodeWithResult, rootNode);
}

function collectSubstring(nodePath) {
  return Belt_List.reduce(nodePath, "", (function (text, node) {
                var text$p = getText(node);
                if (text$p !== undefined) {
                  return text$p + text;
                } else {
                  return text;
                }
              }));
}

function bottom(nodePath) {
  return List.nth(nodePath, 0);
}

var add = Belt_List.add;

var NodePath = {
  collectSubstring: collectSubstring,
  bottom: bottom,
  add: add
};

function allNodePaths($$this) {
  var pathForNode = function (node, currentPath) {
    if (!node) {
      return [
              currentPath,
              undefined
            ];
    }
    var suffixPath = Belt_List.add(currentPath, node);
    return [
            suffixPath,
            suffixPath
          ];
  };
  var traverse = function (state, nodes) {
    return ArrayUtils$SmartcutsMacros.flatMap((function (node) {
                  var match = pathForNode(node, state);
                  var maybeResult = match[1];
                  var childNodes$2 = childNodes$1($$this, node);
                  if (childNodes$2.length !== 0) {
                    return Belt_Array.concat(OptionUtils$SmartcutsMacros.toArray(maybeResult), traverse(match[0], childNodes$2));
                  } else {
                    return OptionUtils$SmartcutsMacros.toArray(maybeResult);
                  }
                }), nodes);
  };
  return traverse(/* [] */0, [/* Root */0]);
}

function allSuffixes($$this) {
  return Belt_Array.map(Belt_Array.keep(allNodePaths($$this), (function (nodePath) {
                    return isLeaf(List.nth(nodePath, 0));
                  })), collectSubstring);
}

var rootNode = /* Root */0;

var $$Node = {
  isRoot: isRoot,
  getText: getText,
  isLeaf: isLeaf,
  childNodes: childNodes$1,
  frequency: frequency
};

exports.makeWithText = makeWithText;
exports.rootNode = rootNode;
exports.$$Node = $$Node;
exports.NodePath = NodePath;
exports.traverse = traverse$1;
exports.allNodePaths = allNodePaths;
exports.allSuffixes = allSuffixes;
/* ./SuffixTree.js Not a pure module */
